import { GetServerSidePropsContext, InferGetServerSidePropsType } from "next";
import { useTranslations } from "next-intl";
import Link from "next/link";
import DynamicParticles, { ISourceOptions } from "react-tsparticles";
import { useMeasure } from "react-use";
import Avatar from "../../common/components/Avatar";
import BaseBanner from "../../common/components/Banner";
import Button from "../../common/components/Button";
import Header from "../../common/components/Header";
import { Collection, LOCALE_OPTIONS } from "../../common/lib/api/base";
import { useBreakpoint } from "../../common/lib/hooks/useWindow";
import { makeAdmin } from "../../common/lib/makeAdmin";
import { toDocs } from "../../common/lib/utils";
import particleConfig from "../../common/particlesjs-config.json";
import {
  HEADER_HEIGHT_MEDIUM,
  HEADER_HEIGHT_MOBILE,
} from "../../common/styles/mixins";
import {
  ArtistContainer,
  ARTIST_AVATAR_SIZE,
  Container,
  Content,
  Main,
  makeBanner,
} from "../../styles/ArtistsList";

const Banner = makeBanner(BaseBanner);

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const locale = ctx.locale as LOCALE_OPTIONS;
  const admin = await makeAdmin();
  const store = admin.firestore();
  const collectionAPI = store.collection("collections");
  const firebaseData = await toDocs<Collection>(collectionAPI.get());
  const artists = firebaseData.map(
    (col) => ({ ...col, ...col.overrides?.[locale] } as Collection)
  );
  return {
    props: {
      artists,
    },
  };
};

const GalleryScreen: React.FC<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = ({ artists }) => {
  const [ref, dim] = useMeasure<any>();
  const isMedium = useBreakpoint("MEDIUM");
  const t = useTranslations("ArtistsList");
  return (
    <>
      <Header />
      <Banner header ref={ref}>
        <DynamicParticles
          height={`${
            dim.height +
            (isMedium ? HEADER_HEIGHT_MEDIUM : HEADER_HEIGHT_MOBILE)
          }px`}
          id="tsparticles"
          options={particleConfig as unknown as ISourceOptions}
        />
        <Content>
          <Container>
            <h1>{t("artists")}</h1>
            <p>{t("subtitle")}</p>
            <Link href={"/contact"}>
              <Button
                title={t("buttonText") as string}
                variant={"white"}
                style={{ margin: "auto" }}
              />
            </Link>
          </Container>
        </Content>
        <div className="shadow" />
      </Banner>
      <div
        style={{
          // backgroundColor: WHITE_BG,
          // color: BLACK_BG,
          paddingTop: "2em",
        }}
      >
        <Main>
          {/* <div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <Input
              value={search}
              onChange={({ target: { value } }) => {
                setSearch(value);
              }}
            />
          </div>
          <TagWrapper>
            {tags.map((tag) => (
              <CategoryTag
                key={tag}
                onClick={() => handleTagSelect(tag)}
                selected={selectedTags.includes(tag)}
              >
                {toNatural(tag || "")}
              </CategoryTag>
            ))}
          </TagWrapper>
        </div> */}
          <h1>{t("our_artists")}</h1>
          <ArtistContainer>
            {artists.map((artist, i) => {
              return (
                <div key={i} className="artist">
                  <Link href={`/artists/${artist.slug}`}>
                    <a>
                      <div className="inner">
                        <Avatar
                          src={artist.image_url.replace("s120", "s250")}
                          size={ARTIST_AVATAR_SIZE}
                          glow="off"
                        />
                        <h3>{artist.name}</h3>
                      </div>
                    </a>
                  </Link>
                </div>
              );
            })}
          </ArtistContainer>
        </Main>
      </div>
    </>
  );
};

export default GalleryScreen;
